import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol } from "@ionic/react";
import { CalculatorFormResult } from "./FormTypes";
import { useTranslation } from "react-i18next";


interface ResultCardProps {
    isCardShowing: boolean;
    result: CalculatorFormResult | null
}

const ResultCard: React.FC<ResultCardProps> = ({ isCardShowing, result }: ResultCardProps) => {
    const { t } = useTranslation();

    const cardContent = () => {
        if (result === null || result.error !== "") {
            return (
                <div>
                    <p>Leider kein Ergebnis verfügbar.</p>
                    <div className="calcErrorBox">{result?.error}</div>
                </div>
            )
        } else {
            return (
                <div>
                    {result.warning !== "" && <div className="calcWarningBox">{result.warning}</div>}
                    <table className="calculatorResultTable">
                        <tbody>
                            <tr>
                                <td><b>v<sub>c</sub></b> ({t("calculatorForm.ResultCard.Schnittgeschw.")})</td>
                                <td>{result?.vc} m/min</td>
                            </tr>
                            <tr>
                                <td><b>n</b> ({t("calculatorForm.ResultCard.Drehzahl")})</td>
                                <td>{result?.n} U/min</td>
                            </tr>
                            <tr>
                                <td><b>v<sub>f</sub></b> ({t("calculatorForm.ResultCard.Vorschubgeschw.")})</td>
                                <td>{result?.vf.toLocaleString()} mm/min</td>
                            </tr>
                            <tr>
                                <td><b>f<sub>z</sub></b> ({t("calculatorForm.ResultCard.Zahnvorschub")})</td>
                                <td>{result?.fz.toLocaleString()} mm</td>
                            </tr>
                            <tr>
                                <td><b>h<sub>m</sub></b> ({t("calculatorForm.ResultCard.Mittlere Spandicke")})</td>
                                <td>{result?.hm.toLocaleString()} mm</td>
                            </tr>
                            <tr>
                                <td><b>Q</b> ({t("calculatorForm.ResultCard.Zeitspanvol.")})</td>
                                <td>{result?.q.toLocaleString()} cm<sup>3</sup>/min</td>
                            </tr>
                            <tr>
                                <td><b>P<sub>mot</sub></b> ({t("calculatorForm.ResultCard.Schnittleistung")})</td>
                                <td>{result?.pmot.toLocaleString()} kW</td>
                            </tr>
                            <tr>
                                <td><b>M</b> ({t("calculatorForm.ResultCard.Drehmoment")})</td>
                                <td>{result?.m.toLocaleString()} Nm</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )
        }
    }

    if (isCardShowing) {
        return (
            <IonCol size="12">
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>{t("calculatorForm.ResultCard.Ergebnis")}</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        {cardContent()}
                    </IonCardContent>
                </IonCard>
            </IonCol>
        )
    }
    return (
        null
    )
}

export default ResultCard;